import { Button } from "@/components/ui/button";
import { Check, ArrowRight } from "lucide-react";
import ScrollLink from "@/components/ScrollLink";

const packages = [
  {
    name: "BDIX Web Hosting",
    price: "599",
    period: "/year",
    description: "Perfect for personal websites",
    features: [
      "1 Website",
      "1 GB NVMe SSD",
      "Unlimited Bandwidth",
      "Free SSL Certificate",
      "LiteSpeed Cache",
      "cPanel Access",
    ],
    popular: false,
    link: "/bdix-web-hosting",
  },
  {
    name: "BDIX Turbo Hosting",
    price: "349",
    period: "/month",
    description: "Entry-level turbo power",
    features: [
      "1 Website",
      "5 GB NVMe SSD",
      "Unlimited Bandwidth",
      "Free SSL Certificate",
      "LiteSpeed Cache",
      "cPanel Access",
    ],
    popular: true,
    link: "/bdix-turbo-hosting",
  },
  {
    name: "BDIX VPS Hosting",
    price: "859",
    period: "/month",
    description: "Full root access VPS",
    features: [
      "1 Core CPU",
      "2 GB RAM",
      "25 GB NVMe SSD",
      "1 TB Bandwidth",
      "Full Root Access",
      "Any OS Support",
    ],
    popular: false,
    link: "/bdix-vps",
  },
];

const PackagesPreview = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-50 text-primary text-sm font-medium mb-4">
            Hosting Plans
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Choose Your Perfect Plan
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Affordable, reliable hosting solutions tailored for every need. All plans include BDIX connectivity.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={pkg.name}
              className={`relative p-8 rounded-2xl bg-card border ${
                pkg.popular ? "border-primary shadow-glow" : "border-border"
              } card-hover animate-fade-in-up`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="gradient-primary text-primary-foreground text-sm font-medium px-4 py-1 rounded-full">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {pkg.name}
                </h3>
                <p className="text-muted-foreground text-sm mb-4">
                  {pkg.description}
                </p>
                <div className="flex items-baseline justify-center gap-1">
                  <span className="text-sm text-muted-foreground">৳</span>
                  <span className="text-4xl font-bold text-foreground">{pkg.price}</span>
                  <span className="text-muted-foreground">{pkg.period}</span>
                </div>
              </div>

              <ul className="space-y-3 mb-8">
                {pkg.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-3">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-sm text-foreground">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button
                variant={pkg.popular ? "gradient" : "outline"}
                className="w-full"
                asChild
              >
                <ScrollLink to={pkg.link}>
                  Order Now
                  <ArrowRight className="ml-2 w-4 h-4" />
                </ScrollLink>
              </Button>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <ScrollLink
            to="/bdix-web-hosting"
            className="inline-flex items-center gap-2 text-primary font-medium hover:underline"
          >
            View All Hosting Plans
            <ArrowRight className="w-4 h-4" />
          </ScrollLink>
        </div>
      </div>
    </section>
  );
};

export default PackagesPreview;
